import { Directive, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors } from '@angular/forms';

import { ValidationRules } from 'rev-shared/util/ValidationRules';

@Directive({
	selector: '[vbInteger],[vb-integer]',
	providers: [{
		provide: NG_VALIDATORS,
		useExisting: forwardRef(() => VbIntegerDirective),
		multi: true
	}],
	standalone: false
})
export class VbIntegerDirective {
	public validate(control: AbstractControl): ValidationErrors {
		return ValidationRules.checkInteger(control.value) ?
			null :
			{ vbInteger: true };
	}
}
